import "../style.scss";
import header from "../../../assets/images/logo_one.svg";
import facebookIcon from "../../../assets/images/Facebook.svg";
import linkedinIcon from "../../../assets/images/Linkedin.svg";
import twitterIcon from "../../../assets/images/Twitter.svg";
import gmailIcon from "../../../assets/images/Gmail.svg";
import React, { useEffect, useMemo, useState } from "react";
import axios from 'axios';
import HP from "../../../host";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useQuery from "../../../hooks/useQuery";
import { ROLES } from "../../../constants";
import backgroundImage from "../../../assets/images/Login .png";
import { Toaster } from "react-hot-toast";
import useCustomToast from "../../../hooks/useCustomToast";
import UserService from "../../../services/user.service";
function Register() {
  const [formData, setFormData] = useState({
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    role: "",
  });

  const [role, setRole] = useState<string>(ROLES.STUDENT);
  const customToast = useCustomToast()
  const navigate = useNavigate()
  const [loading,setLoading] = useState<boolean>(false)
  const handleChangeUser = (e: any) => {
    const { name, value, type } = e.target;
    if (type === "checkbox") {
      setRole(value)
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    formData.role = role
    const combinedFormData = {
      ...formData,
    };
    setLoading(true)
    const response: any = await UserService.register(combinedFormData)
    setLoading(false)
    if (response?.status === 201) {
      customToast("Account created successfully!", "success",2000);
      localStorage.setItem("msg", "Please check your email to verify your account");
      setTimeout(() => {
        navigate("/login")
      }, 2000)
    } else {
      customToast(response?.response?.data?.message || "Registration failed. Please try again.", "error");
    }
  };

  return (
    <div className="auth__page">
      <Toaster />
      <div className="row h-100">
        <div className="col-lg-4 col-md-12 p-0">
          <div className="left">
            <img src={header} className="login_logo register_logo" alt="Pilot Book" />
            <form>
              <h2 className="welcome_ heading2">Register</h2>
              <h4 className="register_subheading heading4">
                Create your free account at Pilots Logbook
              </h4>
              <label className="r_user_label heading4">UserName</label>
              <input
                type="text"
                placeholder="username"
                className="input"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <div className="d-flex gap-3">
                <div className="form_group">
                  <label className="heading4">First Name</label>
                  <input
                    type="text"

                    placeholder="David"
                    className="input"
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form_group">

                  <label className="r_lname_label heading4">Last Name</label>
                  <input
                    type="text"

                    placeholder="Smith"
                    className="input"
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <label className="r_email_label heading4">Email</label>
              <input
                type="text"
                placeholder="Enter Email"
                className="input"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <label className="r_pass_label heading4">Password</label>
              <input
                type="password"
                placeholder="Enter Password"
                className="input"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <div className="d-flex gap-3">
                <div className="checkbox_input">
                  <input
                    type="checkbox"
                    name="student"
                    checked={role === ROLES.STUDENT}
                    value={"student"}
                    onChange={handleChangeUser}
                  />
                  <label className=" heading4">
                    student
                  </label>
                </div>
                <div className="checkbox_input">
                  <input
                    type="checkbox"
                    name="instructor"
                    checked={role === ROLES.INSTRUCTOR}
                    value={"instructor"}
                    onChange={handleChangeUser}
                  />
                  <label className=" heading4">
                    instructor
                  </label>

                </div>
              </div>
              <button className="login_btn" onClick={handleSubmit} disabled={loading}>
                {loading ? "Creating Account" : "Register"}
              </button>
            </form>
            {/* <h4 className="heading4">Login in with</h4>
            <div className="social_icons">
              <img src={gmailIcon} alt="Gmail Icon" />
            </div> */}
            <h4 className="login_now heading4">
              Already have an account ?
              <Link to="/login">
                <span style={{ textDecoration: "underline", color: "#232629" }}>
                  Login
                </span>
              </Link>
            </h4>
            <h5 className="term_of_use heading4">
              By registering you agree to the our Terms of Use
            </h5>
            <h4 className="copyright heading4">© 2023 Pilots Logbook</h4>
          </div>
        </div>
        <div className="col-lg-8 d-none d-md-block h-auto p-0">
          <div className="background">
            <img src={backgroundImage} className="login_bg" alt="Login Background" />
            <div className="content">
              <h4 className="login_bg_heading">
                The most complete digital pilot logbook
              </h4>
              <h4 className="login_bg_subheading">
                Pilots Logbook makes your life easier through its super fast flight
                logging, detailed analysis of your flight time with the Analyze view,
                the powerful InSight technology that monitors all your upcoming flights
                and warns you of any rest / duty / currency issues, with all your
                irreplaceable flying life backed up to your choice of iCloud, Dropbox,
                or both!
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
